
/*function numberWithCommas(x) {
    const y = parseFloat(x).toFixed(2);
    if(!y || y==0.0){
      return 0.00;
    }
    if (y > 900) {
      return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return parseFloat(y).toFixed(2);
    }
  } */

  function currencyFormat(num, currencySymbol) {
    if(num){
      return currencySymbol+' '+parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    else {
      return currencySymbol+' 0.00';
    }
 }

 // Clear local data
 function clearLocalData(){
  localStorage.removeItem("user_text_obj_data1");
  localStorage.removeItem("currency");
  localStorage.removeItem("user_text_obj_data2");
  localStorage.removeItem("monthStartDate");
 }
 
  // Dynamic classes for Monthly Transaction
  const getBadgeClasses = (obj, session) => {
    let classes = "";
    if(obj.budget_type=="1" && obj.sum>0){
      classes += "payment-success";
    }
    else if(session == "current" || session == "next"){
      if (parseFloat(obj.sum) == parseFloat(obj.amount) && parseFloat(obj.sum) > 0) {
        classes += "payment-success";
      }
      else if((parseFloat(obj.sum) > parseFloat(obj.amount)) && parseFloat(obj.amount) == "0.00"){
        classes+= "payment-general";
      }
      else if(parseFloat(obj.sum) > parseFloat(obj.amount)){
        classes += "payment-over";
      } else if (
        parseFloat(obj.sum) > 0 &&
        parseFloat(obj.sum) < parseFloat(obj.amount)
      ) {
        classes += "payment-partial";
      }  
    } else {
        classes += "payments-past";
    }
    return classes;
  };

  // Change date Format
  const changeDateFormat = (date) =>{
    const d = new Date(date);
    return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;

  }

  function getOrdinal(n) {
    let ord = 'th';
  
    if (n % 10 == 1 && n % 100 != 11)
    {
      ord = 'st';
    }
    else if (n % 10 == 2 && n % 100 != 12)
    {
      ord = 'nd';
    }
    else if (n % 10 == 3 && n % 100 != 13)
    {
      ord = 'rd';
    }
  
    return n+ord;
  }

  const generateToken =()=>{

    const str1 = ["A","s","p","E","G","j","l","m","v","w","z","p","b"];
    const str2 = ["B","o","w","c","a","x","i","r","S","u","y","d","f"];
    const platform = 1; // 1: web; 2: android; 3: ios
    const version = "12";
    const date1 = new Date().getTime();
    
    const date1Arr = (date1).toString().split('').reverse();
    let finalStr = '';
    for(let i=0; i<date1Arr.length; i++){
        finalStr = i%2==0 ? finalStr + str2[parseInt(date1Arr[i])] : finalStr + str1[date1Arr[i]]; 
    }
    return Math.random().toString(36).substr(2).substring(0, 7) +platform+'xx'+version+'yy'+finalStr+ Math.random().toString(36).substr(2).substring(0, 7);
  }

  // check leap year
const calculateFebDays =  (year) => {
  //three conditions to find out the leap year
  if ((year % 4 == 0) && (year % 100 !== 0) || (year % 400 == 0)) {
    return 29;
  } else {
      return 28;
  }
};

function escapeHtml(text) {
  var map = {
    '&amp;': '&',
    '&#038;': "&",
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': "'",
    '&#8217;': "’",
    '&#8216;': "‘",
    '&#8211;': "–",
    '&#8212;': "—",
    '&#8230;': "…",
    '&#8221;': '”'
  };
  
  return text.replace(/\&[\w\d\#]{2,5}\;/g, (m) => map[m] ?? m);
}
  
  // const encryptData =(data) =>{
  //   // Encode the String
  //   return 'klkl';
  //   // const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  //   // return 'GEfghj'+encrypted+'WEerjhjh';
  //   }

  // const decryptData = (string) =>{
  //   // Decode the String
   
    
  // }

  module.exports = {
    currencyFormat,
    clearLocalData,
    getBadgeClasses,
    changeDateFormat,
    // encryptData,
    getOrdinal,
    generateToken,
    calculateFebDays,
    escapeHtml
  }